module.exports = new __parcel__URL__("onboarding.d274e357.svg").toString();